import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    messagesDialog: [],
    messagesDialogChat: [],
    loaded: false,
    messageModelDef: {
        id: null,
        title: 'Название сообщения',
        text: '',
        keyboard_id: null,
        name: null,
        type: null,
        result: null,
        attachment: null,
        parent: null,
        bot_id: null,
        action: null,
        private_answer: 1,
        next_message_id: null,
        words_to_find: null,
        chain: null,
        answer_title: null,
        location: null,
        equation: null,
        error: null,
        answer_title_id: null,
        module_group_id: null,
        type_w: null,
        sleep_type: 0,
        sleep_chain: 0,
        rnd: -1,
        priority: 0,
        find_type: 0,
        mailing_i: 0,
        hotkey: 0,
        dont_parse_links: 0,
        work: 1,
        created_at: null,
        message_list_id: null
    },
    messageLists: [],
    unsortedMessagesListId: null,
    messageSortedInList: {},
    unsortedMessages: [],
    messageListsLoaded: false,
    messagesLoaded: false,
    messageListModelDef: {
        bot_id: null,
        title: '',
        messages: null,
        created_at: null,
        deleted: 0,
        visible: 1
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
